module.exports = __webpack_public_path__ + "8e1c706c451f312a975b0806c5fc8f85.svg";